import { createAction } from '@af-common/Common/_actions/Action';

export enum ModuleCreatorActionType {
	OnModuleCreatorOpen			= 'ON_MODULE_CREATOR_OPEN',
	OnModuleCreatorOpenToggle	= 'ON_MODULE_CREATOR_OPEN_TOGGLE',
	OnModuleCreatorClose		= 'ON_MODULE_CREATOR_CLOSE',
	OnModuleCreatorSearch		= 'ON_MODULE_CREATOR_SEARCH',
	OnModuleCreatorCategory		= 'ON_MODULE_CREATOR_CATEGORY',
}

export const OnModuleCreatorOpen = (category?: string) => createAction(ModuleCreatorActionType.OnModuleCreatorOpen, {
	category: category
});

export const OnModuleCreatorOpenToggle = (category?: string) => createAction(ModuleCreatorActionType.OnModuleCreatorOpenToggle);

export const OnModuleCreatorClose = () => createAction(ModuleCreatorActionType.OnModuleCreatorClose);

export const OnModuleCreatorSearch = (value: string) => createAction(ModuleCreatorActionType.OnModuleCreatorSearch, {
	value: value
});

export const OnModuleCreatorCategory = (value: string) => createAction(ModuleCreatorActionType.OnModuleCreatorCategory, {
	value: value
});

export type ModuleCreatorAction = 
	ReturnType<typeof OnModuleCreatorOpen>		|
	ReturnType<typeof OnModuleCreatorClose>		|
	ReturnType<typeof OnModuleCreatorSearch>	|
	ReturnType<typeof OnModuleCreatorCategory>	|
	ReturnType<typeof OnModuleCreatorOpenToggle>